module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "categories"
  }, _vm._l((_vm.categories), function(category, key) {
    return _c('div', {
      staticClass: "cat-panel clearfix hideme",
      class: category.class,
      on: {
        "click": function($event) {
          _vm.buildRipple(key, $event)
        }
      }
    }, [_c('img', {
      class: {
        'col-xs-12 hidden-sm hidden-md hidden-lg nopadding': category.fileNameLarge
      },
      attrs: {
        "src": _vm.loadImage(category.fileName),
        "alt": category.friendly
      }
    }), _vm._v(" "), (category.fileNameLarge) ? _c('img', {
      staticClass: "hidden-xs col-sm-12 col-md-12 col-lg-12 nopadding",
      attrs: {
        "src": _vm.loadImage(category.fileNameLarge),
        "alt": category.friendly
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "cat-title"
    }, [_vm._v(_vm._s(category.friendly))])])
  }))
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-bcf1f594", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bcf1f594","transformToRequire":{"video":["src","poster"],"source":"src","object":"data","iframe":"src","embed":"src","a":"href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Categories.vue
// module id = 419
// module chunks = 0